<div>
  <div class="upgrade-plan-subtitle">
    In order to subscribe to the KELLS Complete Plan, please share your address
    below.<br />NOTE: This is for compliance purposes and will be stored
    privately.
  </div>

  <form [formGroup]="form" class="upgrade-plan-address-form">
    <div class="location-row">
      <mat-form-field>
        <mat-label>Street Address *</mat-label>
        <input matInput formControlName="street" />
        <mat-error
          class="error"
          *ngIf="form.controls['street']?.hasError('required')"
          >Street Address is required</mat-error
        >
      </mat-form-field>

      <mat-form-field>
        <mat-label>City *</mat-label>
        <input matInput formControlName="city" />
        <mat-error
          class="error"
          *ngIf="form.controls['city']?.hasError('required')"
          >City is required</mat-error
        >
      </mat-form-field>
    </div>

    <div class="location-row">
      <mat-form-field>
        <mat-label>State / Town / Province *</mat-label>
        <input matInput formControlName="state" />
        <mat-error
          class="error"
          *ngIf="form.controls['state']?.hasError('required')"
          >State / Town / Province is required</mat-error
        >
      </mat-form-field>

      <mat-form-field>
        <mat-label>Postal / Zip Code *</mat-label>
        <input matInput formControlName="zipcode" />
        <mat-error
          class="error"
          *ngIf="form.controls['zipcode']?.hasError('required')"
          >Postal / Zip Code is required</mat-error
        >
      </mat-form-field>
    </div>
  </form>

  <div class="upgrade-plan-address-footer">
    <a
      href=""
      (click)="onBackToPlansClick($event)"
      class="upgrade-plan-address-footer-back-link"
    >
      < Back to Plans</a
    >

    <button
      class="upgrade-plan-address-footer-upgrade-button"
      (click)="onSubmit()"
      [disabled]="isSubmitting$ | async"
    >
      Continue to KELLS Complete Plan
    </button>
  </div>
</div>
